// ReturnItemsModal.jsx
import React, { useState } from "react";
import { Modal } from "antd";

const ReturnItemsModal = ({ open, onClose, order, onSubmit }) => {
  const [selectedItems, setSelectedItems] = useState([]);

  const toggleItem = (item) => {
    setSelectedItems((prev) => {
      const exists = prev.find((i) => i.itemId === item._id);

      if (exists) {
        // Remove item
        return prev.filter((i) => i.itemId !== item._id);
      } else {
        // Add item with quantity
        return [...prev, { itemId: item._id, quantity: item.quantity }];
      }
    });
  };

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(selectedItems);
    }
  };

  // Filter out items already refunded
  const alreadyRefunded = order?.refundRequests?.map((r) => r.itemId) || [];
  const refundableItems = order?.items?.filter(
    (item) => !alreadyRefunded.includes(item._id)
  );

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      closable={false}
      wrapClassName="return-modal-wrapper"
    >
      <div className="return-modal">
        {/* Top-right close button */}
        <button className="refund-modal-close-top" onClick={onClose}>
          ✕
        </button>

        {/* Header */}
        <div className="return-modal-header">
          <h3>Select items to return</h3>
        </div>

        {/* Items */}
        {refundableItems?.length > 0 ? (
          refundableItems?.map((item, index) => {
            const isChecked = selectedItems.some((i) => i.itemId === item._id);

            return (
              <div
                className={`return-item-card ${isChecked ? "selected" : ""}`}
                key={index}
                onClick={() => toggleItem(item)}
              >
                <div className="item-left">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="item-thumb"
                  />
                  <div className="item-text">
                    <div className="item-name">{item.name}</div>
                    <div className="item-qty">Qty: {item.quantity}</div>
                  </div>
                </div>

                <label
                  className="checkbox-circle"
                  onClick={(e) => e.stopPropagation()}
                >
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => toggleItem(item)}
                  />
                  <span className="checkbox-ui" />
                </label>
              </div>
            );
          })
        ) : (
          <p id="nothing-to-refund-text">Nothing to refund</p>
        )}

        {/* Submit */}
        {refundableItems?.length > 0 && (
          <button
            className="gradient-btn"
            onClick={handleSubmit}
            disabled={selectedItems.length === 0}
          >
            Submit Refund Request
          </button>
        )}
      </div>
    </Modal>
  );
};

export default ReturnItemsModal;
